const restaurant = ({ order }) => {
  return (
    <>
      <div className="map-marker-hint--title">
        <strong>{order.restaurant_name}</strong>
      </div>
    </>
  );
};
export default restaurant;
